module.exports = __webpack_public_path__ + "static/media/truck.5a290bf5.png";